// 청크 정의 — 순수 함수 (기획서 8.2.1)
// 청크 = 연속된 block 묶음. 약 500KB 또는 200 block 중 먼저 도달하는 쪽 (튜닝값).
// 청크 경계는 항상 block 경계와 일치 (8.2.0 강제 분할 덕분).

export const CHUNK_MAX_CHARS = 500 * 1024; // 약 500KB
export const CHUNK_MAX_BLOCKS = 200;

/**
 * blocks → chunks.
 * 반환 chunk: { chunkIndex, blockFrom, blockTo, charStart, charEnd }
 */
export function buildChunks(blocks, maxChars = CHUNK_MAX_CHARS, maxBlocks = CHUNK_MAX_BLOCKS) {
  const chunks = [];
  if (blocks.length === 0) return chunks;

  let from = 0;
  while (from < blocks.length) {
    let charCount = 0;
    let to = from;
    while (
      to < blocks.length &&
      to - from < maxBlocks &&
      (charCount === 0 || charCount + (blocks[to].end - blocks[to].start) <= maxChars)
    ) {
      charCount += blocks[to].end - blocks[to].start;
      to++;
    }
    if (to === from) to = from + 1; // 단일 거대 block 안전장치
    chunks.push({
      chunkIndex: chunks.length,
      blockFrom: from,
      blockTo: to - 1,
      charStart: blocks[from].start,
      charEnd: blocks[to - 1].end,
    });
    from = to;
  }
  return chunks;
}

// globalOffset → chunkIndex. chunks 이진 탐색 (기획서 8.2.4 findChunkByOffset).
export function findChunkByOffset(chunks, globalOffset) {
  if (chunks.length === 0) return -1;
  let lo = 0;
  let hi = chunks.length - 1;
  if (globalOffset <= chunks[0].charStart) return 0;
  if (globalOffset >= chunks[hi].charEnd) return hi;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const c = chunks[mid];
    if (globalOffset < c.charStart) hi = mid - 1;
    else if (globalOffset >= c.charEnd) lo = mid + 1;
    else return mid;
  }
  return Math.min(lo, chunks.length - 1);
}

// blockIndex 가 속한 chunkIndex
export function findChunkByBlock(chunks, blockIndex) {
  for (let i = 0; i < chunks.length; i++) {
    if (blockIndex >= chunks[i].blockFrom && blockIndex <= chunks[i].blockTo) return i;
  }
  return -1;
}
